import Vue from 'vue'
import Vuex from 'vuex'
import logger from 'vuex/dist/logger'
import getters from './getters'
import rnr from './modules/rnr'
import markup from './modules/markup'
import user from './modules/user'
import device from './modules/device'
import dict from './modules/dict'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    rnr,
    markup,
    user,
    device,
    dict
  },
  getters,
  plugins: process.env.NODE_ENV !== 'production' ? [logger()] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js